export default {
    // special cost
    'BLOCKER': null,

    // special moving point
    'INFINITY': undefined,
};